/**
 * Diccionario de equivalencias del buscador (español ⇄ inglés y variantes del jugador).
 * Escribir cualquiera de los términos de un grupo también encuentra los demás.
 * Ampliable: agrega un grupo nuevo o un término a un grupo existente.
 * Solo equivalencias de palabras: no crea objetos ni traduce identificadores.
 */
export const synonymGroups: string[][] = [
  ['joya', 'joyas', 'jewel', 'jewels', 'jwl'],
  ['chaos', 'caos'],
  ['bless', 'bendicion'],
  ['soul', 'alma'],
  ['life', 'vida'],
  ['creation', 'creacion'],
  ['horario', 'horarios', 'hora', 'horas', 'cuando', 'schedule'],
  ['donde', 'ubicacion', 'aparece', 'aparicion', 'apariciones', 'encuentra', 'conseguir', 'obtener', 'obtiene'],
  ['drop', 'drops', 'recompensa', 'recompensas', 'premio', 'premios', 'botin', 'loot', 'entrega'],
  ['dragon', 'dragones'],
  ['wizard', 'mago', 'hechicero'],
  ['skeleton', 'esqueleto'],
  ['king', 'rey'],
  ['rabbit', 'rabbits', 'conejo', 'conejos'],
  ['summer', 'verano'],
  ['invasion', 'invasiones'],
  ['ring', 'anillo'],
  ['excellent', 'excelente', 'exe', 'exc'],
  ['mapa', 'mapas', 'map'],
  ['evento', 'eventos', 'event', 'events'],
  ['probabilidad', 'chance', 'porcentaje'],
  ['jefe', 'boss', 'bosses', 'jefes'],
  ['item', 'items', 'objeto', 'objetos'],
  ['spot', 'spots', 'farmeo', 'farmear', 'farm'],
  ['nivel', 'level', 'lvl', 'requisito', 'requisitos'],
  ['monstruo', 'monstruos', 'monster', 'mob', 'mobs'],
  ['caja', 'box', 'bolsa'],
  // Tipos de equipo (los ítems se llaman en inglés dentro del juego)
  ['casco', 'cascos', 'helm', 'helmet'],
  ['armadura', 'armaduras', 'armor', 'armour'],
  ['pantalon', 'pantalones', 'pants'],
  ['guante', 'guantes', 'gloves', 'glove'],
  ['bota', 'botas', 'boots'],
  ['espada', 'espadas', 'sword', 'blade'],
  ['escudo', 'escudos', 'shield'],
  ['arco', 'arcos', 'bow'],
  ['ballesta', 'ballestas', 'crossbow'],
  ['baston', 'bastones', 'staff', 'stick'],
  ['hacha', 'hachas', 'axe'],
  ['lanza', 'lanzas', 'spear', 'lance'],
  ['cetro', 'cetros', 'scepter'],
  ['collar', 'collares', 'pendant', 'necklace'],
  // Progresión, alas y crafteos
  ['alas', 'ala', 'wings', 'wing'],
  ['capa', 'capas', 'cape', 'capes', 'manto'],
  ['evo', 'evolucion', 'evoluciones', 'evolucionar', 'evoluciono', 'evoluciona'],
  ['quest', 'quests', 'mision', 'misiones'],
  ['pergamino', 'pergaminos', 'scroll', 'scrolls'],
  ['orbe', 'orbes', 'orb', 'orbs'],
  ['libro', 'libros', 'book', 'books', 'librito'],
  ['pluma', 'plumas', 'feather', 'feathers'],
  ['llama', 'flame', 'flama'],
  ['maquina', 'machine', 'goblin', 'combinacion', 'combinaciones', 'combinar', 'mezcla'],
  ['receta', 'recetas', 'crear', 'fabricar', 'craft', 'crafteo', 'crafteos'],
  // "dragón rojo", "mago blanco", "espíritu maligno"… se resuelven como expresiones completas
  // en data/guide/itemTranslations.ts, no traduciendo palabras sueltas.
  ['desbloquear', 'desbloqueo', 'desbloquea', 'activar'],
  ['primera', 'primeras', 'primer', 'first'],
  ['segunda', 'segundas', 'second'],
  ['tercera', 'terceras', 'third'],
  ['clase', 'clases', 'class', 'personaje', 'pj'],
  // Estadísticas y builds. "vida" NO se une a vitalidad: puede ser HP o Vitalidad según el contexto.
  ['fuerza', 'strength', 'str'],
  ['agilidad', 'agility', 'agi'],
  ['vitalidad', 'vitality', 'stamina', 'estamina', 'vit'],
  ['energia', 'energy', 'ene'],
  ['comando', 'command', 'cmd'],
  ['build', 'builds', 'distribucion', 'reparto', 'puntos', 'stats', 'estadisticas'],
  ['bufeadora', 'buffer', 'soporte', 'apoyo'],
]

/** Palabras que no aportan a la búsqueda (verbos de pregunta habituales incluidos). */
export const stopWords = [
  'de', 'del', 'la', 'el', 'los', 'las', 'un', 'una', 'unos', 'unas', 'que', 'como', 'cual', 'cuales',
  'se', 'en', 'por', 'para', 'y', 'o', 'a', 'al', 'mi', 'mis', 'tu', 'es', 'son', 'hay', 'puedo',
  'puede', 'con', 'sin', 'lo', 'le', 'les', 'me', 'su', 'sus', 'of', 'the', 'esta', 'este', 'estan',
  'necesito', 'necesita', 'quiero', 'busco', 'hago', 'hacer', 'consigo', 'cae', 'caen', 'dropea',
  'dropean', 'suelta', 'sueltan', 'entro', 'entrar', 'sale', 'salen', 'saco', 'how', 'where', 'what',
]
